import { ApiResponse } from '../schemas/apiResponseSchema';
import apiClient from '../clients/apiClient';
import { Schemas } from '../types/api-types';

type LoginResponse = Schemas['LoginResponse'];
type ProfileResponse = Schemas['AuthResponse'];
export type UserGroupsResponse = Schemas['UserGroupsResponse'];

export async function login(user_name: string, password: string): Promise<LoginResponse> {
    try {
        const response: ApiResponse<LoginResponse> = (await apiClient.post('/auth/login', { user_name, password })).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.detail || 'Login failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export async function logout() {
    try {
        await apiClient.post('/auth/logout');
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.detail || 'Logout failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export async function getProfile(): Promise<ProfileResponse> {
    try {
        const response: ApiResponse<ProfileResponse> = (await apiClient.get('/profile/me')).data;
        return response.data;
    } catch (error: any) {
        throw error;
    }
}

export async function getAllUserGroups(): Promise<UserGroupsResponse[]> {
    try {
        const response: ApiResponse<UserGroupsResponse[]> = (await apiClient.get('/users/groups/all')).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.detail || 'Fetching user groups failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export async function firstTimeLogin(user_id: number, user_name: string, updated_user_name: string, password: string, token: string): Promise<LoginResponse> {
    try {
        const response: ApiResponse<LoginResponse> = (await apiClient.post('/auth/first_time_login', {
            user_id,
            user_name,
            updated_user_name,
            password,
            token
        })).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.detail || 'First time login failed');
        }
        throw new Error('network error, please contact support team');
    }
}